import { ComponentCollection } from "survey-core";
import {
  billOfMaterialsQuestion,
  billOfProcessesQuestion,
  contractorFormQuestion,
  productsQuestion,
  crpPPGlobalSelectorQuestion,
} from "./components/survey/questions";
import { withPanelTriggerRelay } from "./utils/composite-in-dynamic-panel";

/**
 * Every composite is registered through `withPanelTriggerRelay` so that its
 * inner value changes reach the siblings of a dynamic panel it is dropped into.
 * Without it a `{panel.<composite>.<inner>}` reference in a sibling's
 * `setValueExpression` never re-evaluates.
 *
 * @see src/utils/composite-in-dynamic-panel.ts - what the relay does and why
 */
ComponentCollection.Instance.add(withPanelTriggerRelay(contractorFormQuestion));
ComponentCollection.Instance.add(withPanelTriggerRelay(billOfMaterialsQuestion));
ComponentCollection.Instance.add(withPanelTriggerRelay(productsQuestion));
ComponentCollection.Instance.add(withPanelTriggerRelay(billOfProcessesQuestion));
ComponentCollection.Instance.add(
  withPanelTriggerRelay(crpPPGlobalSelectorQuestion)
);
